import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Card, Form, Input, notification} from 'antd';

import {startStockTake} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {bindActionCreators} from "redux";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class StartStockTakeForm extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    /* actions */
    startStockTake: PropTypes.func.isRequired,
    /* state */
    loading: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
    salonId: PropTypes.string.isRequired,
  };
  // componentDidMount() {
  //   this._load();
  // }
  //
  // componentDidUpdate(prevProps) {
  //   if (this.props.salonId !== prevProps.salonId) this._load();
  // }
  //
  // _load() {
  //   const {salonId} = this.props;
  //   this.props.getSuppliers({salonId});
  // }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {salonId} = this.props;
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.startStockTake({...values, salonId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    return (
      <Card title="Start Stock-take">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Description"
          >
            {getFieldDecorator('description', {
              initialValue: '',
              rules: [{
                required: true,
                message: 'Description is required'
              }]
            })(
              <TextArea/>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Start Stock-take
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const StartStockTakePage = Form.create()(StartStockTakeForm);

const mapStateToProps = state => ({
  loading: state.supplier.gettingSuppliers,
  salonId: state.salon.selectedSalonId,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  startStockTake,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(StartStockTakePage);



// WEBPACK FOOTER //
// ./src/StockTake/StartStockTakePage.js